<template>
  <div class="recording-info">
    <template v-if="recording">
      <h1>Here is some Info About this Recording</h1>
      <br>
      <p>Video Id: {{recording._id}}</p>
      <!-- <p>Length: {{calculateLength(recording.videos[0].start, recording.videos[0].end)}} minutes</p> -->
      <p>Created: {{recording.created | prettyDate}}</p>
    </template>
    <h1 v-else>
      No recording selected
    </h1>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'RecordingInfo',
  computed: {
    ...mapGetters({
      recording: 'recordings/current',
    }),
  },
  methods: {
    calculateLength(start, stop) {
      const a = moment(start);
      const b = moment(stop);
      return b.diff(a, 'minutes');
    },
  },
};
</script>

<style lang="scss" scoped>
  .recording-info {
    padding: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RecordingInfo.vue